import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
    //   mode: "history",
    mode: 'hash',
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {x: 0, y: 0};
        }
    },
    routes: [{
		    path: "/",
		    redirect: {
		        name: "index"
		    }
		},{
            path: "/ad",
            name: "ad",
            component: () =>
                import("./views/index/ad.vue")
        },{
            path: "/index",
            name: "index",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/index/index.vue")
        },{
            path: "/agree",
            name: "agree",
            component: () =>
                import("./views/index/agree.vue")
        },{
		    path: "/trading",
		    name: "trading",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/trading/index.vue")
		},{
		    path: "/tradinghis",
		    name: "tradinghis",
		    redirect: {
		        name: "trading"
		    }
		},{
		    path: "/item",
		    name: "item",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/item/index.vue")
		},{
		    path: "/item/:code",
		    name: "itemDetail",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/item/detail.vue")
		},{
		    path: "/doinvest/:code",
		    name: "doinvest",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/item/buy.vue")
		},{
		    path: "/activity",
		    name: "activity",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/activity/index.vue")
		},{
		    path: "/activity/:code",
		    name: "activityDetail",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/activity/detail.vue")
		},{
		    path: "/odetail/:code",
		    name: "odetail",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/odetail.vue")
        },{
            path: "/user",
            name: "user",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/index.vue")
        },{
            path: "/goodList",
            name: "goodList",
            component: () =>
                import(/* webpackChunkName: "shop" */ "./views/shop/goodList.vue")
        },{
            path: "/good/:id",
            name: "goodDetail",
            component: () =>
                import(/* webpackChunkName: "shop" */ "./views/shop/goodDetail.vue")
        },{
            path: "/favorites",
            name: "favorites",
            component: () =>
                import(/* webpackChunkName: "shop" */ "./views/shop/favorites.vue")
        },{
            path: "/cart",
            name: "cart",
            component: () =>
                import(/* webpackChunkName: "shop" */ "./views/shop/cart.vue")
        },{
            path: "/orderhis",
            name: "orderhis",
            component: () =>
                import(/* webpackChunkName: "shop" */ "./views/shop/orderhis.vue")
        },{
            path: "/shopOrder/:id",
            name: "shopOrderDetail",
            component: () =>
                import(/* webpackChunkName: "shop" */ "./views/shop/shopOrderDetail.vue")
        },{
            path: "/pay",
            name: "pay",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/pay.vue")
        },{
		    path: "/account",
		    name: "account",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/account.vue")
		},
		{
		    path: "/addcount",
		    name: "addcount",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/addcount.vue")
		},
		{
		    path: "/addcountUsdt",
		    name: "addcountUsdt",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/addcountUsdt.vue")
		},{
		    path: "/transfer",
		    name: "transfer",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/transfer.vue")
		},{
		    path: "/moneybag",
		    name: "moneybag",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/moneybag.vue")
		},
		{
		    path: "/rechargeRecord",
		    name: "rechargeRecord",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/rechargeRecord.vue")
		},
		{
		    path: "/withdrawRecord",
		    name: "withdrawRecord",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/withdrawRecord.vue")
		},{
            path: "/login",
            name: "login",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/login.vue")
        },{
            path: "/cashlist",
            name: "cashlist",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/cashlist.vue")
        },
		{
		    path: "/download",
		    name: "download",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/download.vue")
		},
        {
            path: "/register",
            name: "register",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/register.vue")
        },
        {
            path: "/forgetpwd",
            name: "forgetpwd",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/forgetpwd.vue")
        },{
            path: "/invest2",
            name: "invest2",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/invest2.vue")
        },{
            path: "/invest",
            name: "invest",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/invest.vue")
        },{
            path: "/invest/trx/:code",
            name: "investtrx",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/invest.vue")
        // },{
        //     path: "/invest/alipay",
        //     name: "pay",
        //     component: () =>
        //         import(/* webpackChunkName: "home" */ "./views/user/invest_qrcode.vue")
        },
        {
            path: "/invest/wx",
            name: "wx",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/invest_qrcode.vue")
        },
		{
		    path: "/invest/usdt",
		    name: "usdt",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/invest_qrcode.vue")
		},
        {
            path: "/invest/bank",
            name: "bankpay",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/invest_bank.vue")
        },{
            path: "/cash",
            name: "cash",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/cash.vue")
        },{
            path: "/cash2",
            name: "cash2",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/cash2.vue")
        },{
            path: "/vip",
            name: "vip",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/vip.vue")
        },{
            path: "/teamhis",
            name: "teamhis",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/teamhis.vue")
        },{
            path: "/teamreg",
            name: "teamreg",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/teamreg.vue")
        },{
            path: "/safe",
            name: "safe",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/safe.vue")
        },
        {
            path: "/setpwd",
            name: "setpwd",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/setpwd.vue")
        },
        {
            path: "/setpaypwd",
            name: "setpaypwd",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/setpaypwd.vue")
        },{
            path: "/order",
            name: "order",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/order.vue")
        },{
		    path: "/ordering",
		    name: "ordering",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/ordering.vue")
		},{
		    path: "/orderfrezee",
		    name: "orderfrezee",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/orderfrezee.vue")
		},{
		    path: "/ordersettle",
		    name: "ordersettle",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/ordersettle.vue")
		},
		{
		    path: "/ordered",
		    name: "ordered",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/ordered.vue")
		},
		{
		    path: "/addr",
		    name: "addr",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/addr.vue")
		},
		{
		    path: "/shippingAddress",
		    name: "shippingAddress",
		    component: () =>
		        import(/* webpackChunkName: "shop" */ "./views/user/shippingAddress.vue")
		},
		{
		    path: "/odetail",
		    name: "odetail",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/odetail.vue")
		},
		{
		    path: "/grap",
		    name: "grap",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/grap.vue")
		},
        {
            path: "/funds",
            name: "funds",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/funds.vue")
        },
		{
		    path: "/myTeam",
		    name: "myTeam",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/myTeam.vue")
		},
        {
            path: "/notice",
            name: "notice",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/notice.vue")
        },
        {
            path: "/notice/:id",
            name: "noticeid",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/notice_article.vue")
        },
        {
            path: "/agreement/:id",
            name: "agreement",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/agreement.vue")
        },
        {
            path: "/about",
            name: "about",
            component: () =>
                import( "./views/user/about.vue")
        },
        {
            path: "/about/:code",
            name: "article",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/article.vue")
        },

		{
		    path: "/search",
		    name: "search",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/item/search.vue")
		},
        {
            path: "/kefu",
            name: "kefu",
            component: () =>
                import(/* webpackChunkName: "home" */ "./views/user/kefu.vue")
        },
		{
		    path: "/kefu2",
		    name: "kefu2",
		    component: () =>
		        import("./views/user/kefu2.vue")
		},
        // {
        //     path: "/sign",
        //     name: "sign",
        //     component: () =>
        //         import(/* webpackChunkName: "home" */ "./views/user/sign.vue")
        // },
		{
		    path: "/luckDraw",
		    name: "luckDraw",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/luckDraw.vue")
		},
		{
		    path: "/authEmail",
		    name: "authEmail",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/authEmail.vue")
		},

		{
		    path: "/language",
		    name: "language",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/user/language.vue")
		},
        {
		    path: "/video",
		    name: "video",
		    component: () =>
		        import(/* webpackChunkName: "home" */ "./views/video/video.vue")
		},
    ]
});
